import { render, staticRenderFns } from "./PageEditorContentAreaPanel.vue?vue&type=template&id=2e67dffc&scoped=true"
import script from "./PageEditorContentAreaPanel.vue?vue&type=script&lang=js"
export * from "./PageEditorContentAreaPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e67dffc",
  null
  
)

export default component.exports